import { render, staticRenderFns } from "./CategoryTable.vue?vue&type=template&id=fe62797a&scoped=true&"
import script from "./CategoryTable.vue?vue&type=script&lang=js&"
export * from "./CategoryTable.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTable.vue?vue&type=style&index=0&id=fe62797a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe62797a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VIcon,VSimpleTable})
